import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import authorsTableData from "./table-data";
// Data

// Redux and API
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../../redux/Reducers/GlobalReducer/globalSlice";
import { useSnackbarContext } from "components/SnackBarContext";
import { API_FAIL_MESSAGE, SUCCESS } from "constants/apiConstants";
import { API_ENDPOINTS } from "constants/apiConstants";
import api from "services/api";

function PropertyInventory() {
  const [tableData, setTableData] = useState([]);
  const [open, setOpen] = useState(false);
  const [newTitle, setNewTitle] = useState("");
  const [newDescription, setNewDescription] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [editingItem, setEditingItem] = useState(null);
  const auth = useSelector((state) => state.auth);
  const { IsLoginData } = auth;
  // console.log("IsLoginData", IsLoginData);
  const tableName = "Inventory";
  const dispatch = useDispatch();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbarContext();
  const [communities, setCommunities] = useState([]);
  const [selectedCommunity, setSelectedCommunity] = useState(null);
  const [selectedCommunityId, setSelectedCommunityId] = useState(null);
  const [totalInventory, setTotalInventory] = useState(0);
  const [inventoryLeft, setInventoryLeft] = useState("");

  const handleSubmit = async () => {
    const payload = {
      user_id: IsLoginData.idUser,
      community_id: selectedCommunityId,
      units: inventoryLeft,
    };
    // console.log("payload", payload);
    try {
      dispatch(setLoading(true));
      const response = await api.post(API_ENDPOINTS.ADD_INVENTORY, payload);
      dispatch(setLoading(false));

      const { status, message } = response.data;
      if (status === SUCCESS) {
        getIventoryTableData();
        showSuccessSnackbar(message || "Inventory updated successfully");
        // getTableData();
      } else {
        showErrorSnackbar(message || API_FAIL_MESSAGE);
      }
    } catch (error) {
      dispatch(setLoading(false));
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  useEffect(() => {
    getIventoryTableData();
  }, []);

  const getIventoryTableData = async () => {
    try {
      dispatch(setLoading(true));
      const response = await api.get(API_ENDPOINTS.GET_INVENTORY);
      console.log(`GET ${tableName}`, response);
      dispatch(setLoading(false));
      const { status, data, message } = response.data;
      if (status === SUCCESS) {
        setTableData(data);
      } else {
        showErrorSnackbar(message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Get ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const handleEdit = (item) => {
    setSelectedCommunityId(item.community_id);
    setSelectedCommunity(item.communityname);
    setInventoryLeft(item.units || "");
    setEditingItem(item);
    setOpen(true);
  };
  const { columns, rows } = authorsTableData(tableData, handleEdit);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {tableName}
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  // showTotalEntries={false}
                  // noEndBorder
                  // onApprove={handleApprove}
                  // onCancel={handleCancel}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Edit Inventory</DialogTitle>
        <DialogContent>
          <TextField
            label="Community Name"
            value={selectedCommunity || ""}
            fullWidth
            margin="normal"
            disabled
          />
          <TextField
            label="Add Additional Units"
            type="number"
            value={inventoryLeft}
            onChange={(e) => setInventoryLeft(e.target.value)}
            fullWidth
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleSubmit();
              setOpen(false);
            }}
            sx={{ color: "#fff" }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default PropertyInventory;
